import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import type { AbstractStepProps } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { ButtonLegacy, FormCurrency, FormDecidable, MONTHS_HUN } from "@/shared/ui";
import { formatText } from "@/shared/ui/format";

export interface StepFields {
	loanAmount: number;
	married: boolean;
	hasBothOfTheCoupleHunAddress: boolean;
}

interface Props extends AbstractStepProps {
	variant: "erste" | undefined;
}

const MAX_LOAN_AMOUNT = 11_000_000;

export class Step1 extends AbstractStep<StepFields, Props> {
	protected initValues(): StepFields {
		return {
			loanAmount: undefined,
			married: undefined,
			hasBothOfTheCoupleHunAddress: undefined,
		};
	}

	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		const { variant } = this.props;
		const date = dayjs();

		return (
			<>
				<Card.Header className="bg-secondary-gradient text-white text-center pb-1 pt-3">
					{variant === "erste" ? (
						<>
							<div className="h4 font-weight-light">Derítsd ki, hogy jogosult vagy-e</div>
							<div className="h1 font-weight-bold text-uppercase">GYORSÍTOTT ONLINE</div>
							<div className="h2 font-weight-light text-uppercase">babaváró hitelre</div>
						</>
					) : (
						<div className="display-3 text-uppercase">
							Mennyi <br />
							<strong>Babaváró</strong>
							<br /> hitelt kaphatok?
						</div>
					)}
					<hr className="w-75" />
					<div className="h4 font-weight-light">
						<strong>Akár {variant === "erste" ? "210" : "200"} ezer forint jóváírást</strong>
						<br /> kaphatsz hiteled mellé, ha{" "}
						<strong>
							{date.year()}. <span className="text-lowercase">{MONTHS_HUN[date.month()]}</span> végéig
						</strong>{" "}
						megígényled.
					</div>
					<hr className="w-75" />
				</Card.Header>
				<Card.Body className="pt-3">
					<FormCurrency
						label="Mennyi Babaváró hitelt szeretnétek igényelni?"
						name="loanAmount"
						placeholder="Add meg a hitelösszeget!"
						validate={this.validLoanAmount}
						required
					/>
					<FormDecidable label="Házasok vagytok a pároddal?" name="married" required />
					<FormDecidable
						label="Mindkettőtöknek van magyar lakcíme?"
						name="hasBothOfTheCoupleHunAddress"
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Tovább
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	private validLoanAmount(loanAmount: number): string {
		if (isNaN(loanAmount)) {
			return "Kérjük, add meg a hitelösszeget!";
		}

		if (loanAmount > MAX_LOAN_AMOUNT) {
			return `A hitelösszege maximum ${formatText(MAX_LOAN_AMOUNT, "ft")} lehet.`;
		}
	}

	protected getComponentName(): string {
		return "Step1";
	}
}
